import {ReactNode} from "react";

function Column({side, children}: { side: 'left' | 'right', children: ReactNode }) {
    return (
        <div className={side === 'left' ? "left-column" : "right-column"}>
            {children}
        </div>
    );
}

export const LeftColumn = (props: { children: ReactNode }) => <Column side="left" {...props} />;
export const RightColumn = (props: { children: ReactNode }) => <Column side="right" {...props} />;
